import Home from "../Pages/Home/Home";
import { routes } from "../Constants/Routes";
import Getorder from "../Pages/GetOrder/Getorder";
import NotFound from "../Pages/NotFound/NotFound";
export const RoutersConfig = [
  { path: routes.Home, Component: Home },
  { path: routes.GetOrder, Component: Getorder },
  { path: routes.NotFound, Component: NotFound },
];
